var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-invoice concepts box wrapper-rep-payments" },
    [
      _c("div", { staticClass: "title-container is-flex" }, [
        _c(
          "h3",
          {
            staticClass:
              "title is-centered is-4 has-text-primary title-rep-payments"
          },
          [_vm._v("\n      Pagos\n    ")]
        ),
        _c("div", { staticClass: "field is-centered" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.advanced,
                expression: "advanced"
              }
            ],
            staticClass: "is-checkradio",
            class: { "is-success": _vm.advanced },
            attrs: {
              id: "advanced",
              disabled: _vm.cash,
              name: "advanced",
              type: "checkbox"
            },
            domProps: {
              checked: Array.isArray(_vm.advanced)
                ? _vm._i(_vm.advanced, null) > -1
                : _vm.advanced
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.advanced,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.advanced = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.advanced = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.advanced = $$c
                  }
                },
                _vm.onChangeAdvanced
              ]
            }
          }),
          _c(
            "label",
            { staticClass: "is-centered", attrs: { for: "advanced" } },
            [_vm._v("\n        Opciones Avanzadas\n      ")]
          )
        ]),
        false
          ? _c(
              "div",
              { staticClass: "field is-centered" },
              [
                _c(
                  "BTooltip",
                  { attrs: { label: "Agregar partida", type: "is-success" } },
                  [
                    !_vm.disabled
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "button add-concept is-success is-rounded",
                            on: { click: _vm.addRow }
                          },
                          [
                            _c("BIcon", { attrs: { icon: "plus" } }),
                            _c("span", [
                              _vm._v(
                                "\n             \n            Agregar Pago\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c("AdvancedValues", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.advanced,
            expression: "advanced"
          }
        ]
      }),
      _c("BTable", {
        attrs: {
          data: _vm.concepts,
          columns: _vm.columns,
          "opened-detailed": _vm.openedDetailed,
          detailed: "",
          "detail-key": "id"
        },
        on: { "details-close": _vm.onDetailsClose },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return [
                _c(
                  "span",
                  { class: { "header-label": props.column.label === "SKU" } },
                  [
                    _vm._v(
                      "\n        " + _vm._s(props.column.label) + "\n      "
                    )
                  ]
                ),
                props.column.meta
                  ? _c("AppTooltip", { attrs: { label: props.column.meta } })
                  : _vm._e()
              ]
            }
          },
          {
            key: "default",
            fn: function(props) {
              return [
                _c(
                  "BTableColumn",
                  { attrs: { field: "paymentMethod", internal: "" } },
                  [
                    _c("AppSelectField", {
                      attrs: {
                        id: "wayPay",
                        name: "wayPay",
                        placeholder: "Selecciona la forma de pago",
                        options: _vm.paymentTypeCatalog,
                        value: _vm.wayPay,
                        disabled: _vm.isLoading || _vm.disabled,
                        required: ""
                      },
                      on: {
                        input: function($event) {
                          return _vm.onChangePayment($event, props.row.id)
                        },
                        change: function($event) {
                          return _vm.onChangePayment($event, props.row.id)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "paymentDate", internal: "" } },
                  [
                    _c(
                      "BDatetimepicker",
                      _vm._b(
                        {
                          attrs: {
                            id: "paymentDate",
                            value: _vm.privatePaymentDate,
                            disabled: _vm.isLoading || _vm.disabled,
                            "date-parser": _vm.dateParser,
                            "horizontal-time-picker": "",
                            icon: "calendar-today"
                          },
                          on: {
                            input: function($event) {
                              return _vm.onInput($event, props.row.id)
                            }
                          }
                        },
                        "BDatetimepicker",
                        _vm.calendarProps,
                        false
                      )
                    )
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "currency", internal: "" } },
                  [
                    _c("AppSelectField", {
                      attrs: {
                        id: "currency",
                        name: "currency",
                        placeholder: "Selecciona la moneda",
                        options: _vm.currencyCatalog,
                        value: _vm.paymentCurrency,
                        disabled: _vm.isLoading || _vm.disabled,
                        required: ""
                      },
                      on: {
                        input: function($event) {
                          return _vm.onChangeCurrency($event, props.row.id)
                        },
                        change: function($event) {
                          return _vm.onChangeCurrency($event, props.row.id)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  {
                    attrs: {
                      visible: _vm.isVisible,
                      field: "exchangeRate",
                      internal: ""
                    }
                  },
                  [
                    _c("AppInputField", {
                      attrs: {
                        id: "exchangeRate",
                        name: "exchangeRate",
                        placeholder: "0.00",
                        value: _vm.exchangeRate,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: {
                        input: function($event) {
                          return _vm.onChangePayment($event, props.row.id)
                        },
                        change: function($event) {
                          return _vm.onChangePayment($event, props.row.id)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "voucherSeries", internal: "" } },
                  [
                    _c("AppInputField", {
                      attrs: {
                        id: "voucherSeries",
                        name: "voucherSeries",
                        placeholder: "P",
                        value: _vm.voucherSeries,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: {
                        input: function($event) {
                          return _vm.onChangeInvoice($event, props.row.id)
                        },
                        change: function($event) {
                          return _vm.onChangeInvoice($event, props.row.id)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "voucherConsecutive", internal: "" } },
                  [
                    _c("AppInputField", {
                      attrs: {
                        id: "voucherConsecutive",
                        name: "voucherConsecutive",
                        placeholder: "1",
                        type: "number",
                        min: "1",
                        value: _vm.voucherConsecutive,
                        disabled: _vm.isLoading || _vm.disabled
                      },
                      on: {
                        input: function($event) {
                          return _vm.onChangeInvoice($event, props.row.id)
                        },
                        change: function($event) {
                          return _vm.onChangeInvoice($event, props.row.id)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "BTableColumn",
                  { attrs: { field: "actions", internal: "" } },
                  [
                    _c("span", { staticClass: "actions" }, [
                      _vm.concepts.length > 1
                        ? _c(
                            "a",
                            {
                              staticClass: "button is-danger",
                              on: {
                                click: function($event) {
                                  return _vm.deleteRow(props.row.id)
                                }
                              }
                            },
                            [
                              _c("BIcon", {
                                attrs: { icon: "delete", "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ]
            }
          },
          {
            key: "detail",
            fn: function(props) {
              return [
                _c("DocumentsRelated", {
                  attrs: {
                    id: props.row.id,
                    documents: props.row.documentsRelated
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }